import React, { memo, useCallback, useMemo } from 'react';
import DataGrid from 'components/DataGrid';
import { createUseStyles } from '@Sage/hoi-poi-ui';

import styles from './styles';

const useStyles = createUseStyles(styles, 'Table');

const Table = memo(({ data, isExpanded }) => {
    const classes = useStyles();

    const stopPropagation = useCallback((e) => {
        if (e) e.stopPropagation();
    }, []);

    const columns = useMemo(() => {
        if (!data?.columns?.length) return [];
        return data.columns.map((column) => {
            return {
                field: column.id,
                headerName: column.label,
                valueGetter: (params) => params.data?.[column.id],
            };
        });
    }, [data?.columns]);

    return (
        <div className={classes.root} onMouseDown={stopPropagation}>
            {!data?.data?.length && <div className={classes.empty}>is empty</div>}
            {data?.data?.length && (
                <DataGrid
                    rowData={data.data}
                    columnDefs={columns}
                    defaultColDef={{
                        resizable: isExpanded || false,
                    }}
                />
            )}
        </div>
    );
});

export default Table;
